import keyMirror from 'src/common/utils/keyMirror';

export const providers = keyMirror(
  'apple',
  'google',
  'zuora',
  'recurly',
  'other',
);

const apiProviderMap = {
  'apple.free': providers.apple,
  'apple.pro': providers.apple,
  'google.free': providers.google,
  'google.pro': providers.google,
  zuora: providers.zuora,
  recurly: providers.recurly,
};

export default function getSubscriptionProvider(apiProviderName) {
  return apiProviderMap[apiProviderName] || providers.other;
}
